import { TransportMode } from '@hazmatsuite-next/ui';
import { EasyDgdDataModel } from './easydgd-data.model';

export class EasyDgdState {
  public data: EasyDgdDataModel = {
    TransportMode: TransportMode.Unknown
  };
  public sessionLoaded = false;
}
